import { Link } from 'react-router-dom';
import SummaryCard from '../../components/reusable-elements/summary-card.jsx';
import { SingleStat } from '../../components/reusable-elements/single-stat.jsx';
import { IncomeAndExpenseContainer } from '../../components/dashboard/income-expense-container.jsx';

import 'bootstrap-daterangepicker/daterangepicker.css';

const DashboardV3 = () => {

	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/dashboard/v3">Home</Link></li>
				<li className="breadcrumb-item active"><Link to="/dashboard/v3">Dashboard</Link></li>
			</ol>
			<h1 className="page-header mb-3">My Property Dashboard</h1>
			<IncomeAndExpenseContainer />
			<div className="row">
				<div className="col-xl-6">
					<SummaryCard
						headerTitle="CURRENT MAINTENANCE ISSUES"
						summaryValue="10"
						summaryValueMovement="-2"
						averageValue1="0.57"
						averageValue1Label="Avg. Issues Per Property"
						averageValue2="0.095"
						averageValue2Label="Avg. Issues Per Room">
					</SummaryCard>
				</div>
				<div className="col-xl-3">
					<SingleStat
						headerTitle="MOVE IN NEXT 7 DAYS"
						summaryValue="10"
						summaryValueColour="text-green-500"
						complete={true}
					/>
				</div>
				<div className="col-xl-3">
					<SingleStat
						headerTitle="MOVE OUT NEXT 7 DAYS"
						summaryValue="2"
						summaryValueColour="text-red-500"
						complete={true}
					/>
				</div>
			</div>
		</div>
	);

};

export default DashboardV3;